import {
  Button,
  ControlledInput,
  ControlledTextarea,
  Modal,
  ModalContent,
  ModalTitle
} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'
import {Controller} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {useEditStaticPartForm} from './hooks/useEditStaticPartModal'

import {StaticPartDTO} from '@refra/modules/refra-static-parts/types'

interface EditStaticPartModalProps {
  staticPart: StaticPartDTO
}

export const EditStaticPartModal = ({staticPart}: EditStaticPartModalProps) => {
  const {t} = useTranslation()

  const {
    formMethods: {control, formState},
    isFormBeingProcessed,
    onSubmit,
    onClose
  } = useEditStaticPartForm({staticPart})

  return (
    <Modal open onClose={() => onClose()} data-cy="refra_add_static_part_modal">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className={'flex justify-between'}>
          <ModalTitle data-cy="refra_update_material_modal_title">
            {t('staticParts.editStaticPartModal.title')}
          </ModalTitle>
        </div>
        <ModalContent>
          <div className="flex flex-col gap-4">
            <Controller
              name="name"
              control={control}
              rules={{
                required: t('error.required')
              }}
              render={({field}) => (
                <ControlledInput
                  {...field}
                  label={t('staticParts.table.name')}
                  error={formState.errors.name?.message}
                  isTouched={!!formState.touchedFields.name}
                  isDisabled={isFormBeingProcessed}
                  data-cy="edit_static_part_name_input"
                />
              )}
            />
            <Controller
              name="description"
              control={control}
              rules={{
                required: t('error.required')
              }}
              render={({field}) => (
                <ControlledTextarea
                  {...field}
                  label={t('staticParts.table.description')}
                  error={formState.errors.description?.message}
                  isTouched={!!formState.touchedFields.description}
                  isDisabled={isFormBeingProcessed}
                  data-cy="edit_static_part_description_text_area"
                />
              )}
            />
          </div>
        </ModalContent>
        <div className={'space-x-2 flex justify-end'}>
          <Button
            disabled={isFormBeingProcessed}
            data-cy="cancel_static_part_btn"
            icon={mdiClose}
            onClick={() => onClose()}
            variant="secondary"
          >
            {t('common.cancel')}
          </Button>
          <Button type="submit" disabled={isFormBeingProcessed} data-cy="edit_static_part_btn">
            {t('common.save')}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
